import apiActions from 'react/api/actions';
import { fromJS } from 'immutable';
const { user: { actions } } = apiActions; 

const initialState = fromJS({});

export default (state = initialState, action) => {
    switch (action.type) {
        case actions.updateUser:
          return state.merge(action.payload);
        default:
          return state;
   }
};
